import Backbone from 'backbone';

export default Backbone.Model.extend({
	idAttribute: 'Id',

	defaults: function() {
		return {
			Buy: false,
			Counterparty: '',
			CtrPtyMemberName: null,
			CtrPtyParticipantId: 0,
			CtrPtyParticipantLei: '',
			CtrPtyParticipantName: '',
			Currency: 'CHF',				// defaults to CHF
			Delayed: false,
			Inserted: null,					// date
			InstrumentName: '',
			Isin: '',
			OwnTrade: '',
			ParticipantName: '',
			Price: 0,
			Quantity: 0,
			SetHandled: '',					// url to set handled property
			Settlement: null,				// date,
			SettlementAmount: 0,
			Traded: null,					// date
			TradeReportId: 'unkown',		// prevent template error when no ID is given
			Type: ''						// type of urgent notification

		};
	},

	url: function() {
		return this.get('SetHandledUrl') || document.URL;
	}
});

